import { ADMIN_ROLE, SUPERADMIN_ROLE, hasPermission } from '@carsfinders/auth';

import { useSessionUser } from '../clients/hooks/use-session-user';

export interface SessionRoles {
  /**
   * The signed-in operator's roles (`GET /users/me`). While the profile is
   * still loading this is `[ADMIN_ROLE]` — RequireAdmin only lets an admin
   * this far, so the admin rows may show, but no superuser row flashes in
   * before the real list says so.
   */
  roles: string[];
  isSuperadmin: boolean;
  isLoading: boolean;
}

/** Whether a role list carries the superuser role (owner decision 2026-10-13). */
export function isSuperadmin(roles: string[] | undefined): boolean {
  return hasPermission(SUPERADMIN_ROLE, roles);
}

/** The shell's and the superuser gates' one view of the session's roles. */
export function useSessionRoles(): SessionRoles {
  const { user, isLoading } = useSessionUser();
  const stored = user?.role;
  const roles = Array.isArray(stored) ? stored : [ADMIN_ROLE];
  return { roles, isSuperadmin: isSuperadmin(roles), isLoading };
}
